import { combineReducers } from 'redux';
import {
    RECEIVE_REQUESTCOUNT, SET_PROFILEPAGE, CLEARING_SCHEDULE, REFRESH_SCHEDULE, FILTERED_SHIFT,
    FILTERED_ROLE, FILTERED_EMPLOYEE, UPDATE_SCHEDULEDATE, REQUEST_REQUESTCOUNT, SHOW_TOAST,
UPDATE_APPSTATE,
    RECEIVE_SHIFTS, REQUEST_SHIFTS,
    RECEIVE_WEATHER, REQUEST_WEATHER,
    UPDATE_FETCHING,
 CLOSENAV, SCHEDULECONFLICTS, SCHEDULECONFLICTSONLY, CLOSECHAT, THEME, UPDATE_SCHEDULECLEAR, CHATUSERID
} from '../actions';
import moment from "moment";
import Cookies from 'universal-cookie';



function fetching(state = { fetching: true}, action) {
    switch (action.type) {
        case UPDATE_FETCHING:
            return action.fetching
        default:
            return state
    }
}


// Shifts
function shifts(state = { isFetchingShifts: true, shifts: [], schedules:[] }, action) {
    switch (action.type) {
        case RECEIVE_SHIFTS:
            if (action.shifts.model) {
                return {
                    ...state,
                    schedules: action.shifts.schedules ? action.shifts.schedules : [],
                    isFetchingShifts: false,
                    shifts: action.shifts.model ? action.shifts.model : [],
                    selectShiftsFrom: action.shifts.selectShiftsFrom,
                    employeesAvailability: action.shifts.employeesAvailability,
                }
               
            } else {
                return {
                    ...state,
                    schedules: state.schedules,
                    isFetchingShifts: false,
                    shifts: action.shifts
                }
               
            }
            
        case REQUEST_SHIFTS:
            return Object.assign({}, state, {
                isFetchingShifts: true
            })
        default:
            return state;
    }
}

// weather
function weather(state = { isFetchingWeather: true, weather: [] }, action) {
    switch (action.type) {
        case RECEIVE_WEATHER:
            return Object.assign({}, state, {
                isFetchingWeather: false,
                weather: action.weather
            })
        case REQUEST_WEATHER:
            return Object.assign({}, state, {
                isFetchingWeather: true
            })
        default:
            return state;
    }
}

// End Shifts

var yrd = new moment().toDate();
function scheduleDate(state = yrd, action) {
    switch (action.type) {
        
        case UPDATE_SCHEDULEDATE:
            return action.scheduleDate
        default:
            return state
    }
}

function profilePage(state = null, action) {
    switch (action.type) {
        case SET_PROFILEPAGE:
            return action.profilePage
        default:
            return state
    }
}

function refreshSchedule(state = null, action) {
    switch (action.type) {
        case REFRESH_SCHEDULE:
            return action.refreshSchedule
        default:
            return state
    }
}
function clearingSchedule(state = null, action) {
    switch (action.type) {
        case CLEARING_SCHEDULE:
            return action.clearingSchedule
        default:
            return state
    }
}

function closeChat(state = true, action) {
    switch (action.type) {
        case CLOSECHAT:
            return action.closeChat
        default:
            return state
    }
}

function chatUserId(state = null, action) {
    switch (action.type) {
        case CHATUSERID:
            return action.chatUserId
        default:
            return state
    }
}

function scheduleConflictsOnly(state = false, action) {
    switch (action.type) {
        case SCHEDULECONFLICTSONLY:
            return action.scheduleConflictsOnly
        default:
            return state
    }
}

function scheduleConflicts(state = 0, action) {
    switch (action.type) {
        case SCHEDULECONFLICTS:
            return action.scheduleConflicts
        default:
            return state
    }
}

function closeNav(state = false, action) {
    switch (action.type) {
        case CLOSENAV:
            return action.closeNav
        default:
            return state
    }
}

function isAuthenticated() {
    // Check whether the current time is past the 
    // access token's expiry time
    let expiresAt = new Date(localStorage.getItem('expires_at'));
    let isAuthed = new Date().getTime() < expiresAt;
    return isAuthed;
}
let auth = isAuthenticated()
const cookies = new Cookies();
let t = cookies.get('theme');
t = t ? t : "light"
if (!auth) {
    t = "light"
}

function theme(state = t, action) {
    switch (action.type) {
        case THEME:
            return action.theme
        default:
            return state
    }
}

function scheduleClear(state = null, action) {
    switch (action.type) {
        case UPDATE_SCHEDULECLEAR:
            return action.scheduleClear
        default:
            return state
    }
}

function filteredShift(state = [], action) {
    switch (action.type) {
       
        case FILTERED_SHIFT:
            return action.filteredShift
        default:
            return state
    }
}

function filteredRole(state = [], action) {
    switch (action.type) {
      
        case FILTERED_ROLE:
            return action.filteredRole
        default:
            return state
    }
}

function filteredEmployee(state = [], action) {
    switch (action.type) {
        case FILTERED_EMPLOYEE:
            return action.filteredEmployee
        default:
            return state
    }
}


// Request Count
function requestCount(state = {}, action) {
    switch (action.type) {
        case RECEIVE_REQUESTCOUNT:
            return Object.assign({}, state, {
                isFetchingStats: false,
                count: action.count
            })
        case REQUEST_REQUESTCOUNT:
            return Object.assign({}, state, {
                isFetchingStats: true
            })
        default:
            return state
    }
}
// Request Count

function showToast(state = {show:false,message:""}, action) {
    switch (action.type) {
        case SHOW_TOAST:
            return action.showToast
        default:
            return state
    }
}



export function appReducer(state = {}, action) {
    switch (action.type) {
        case UPDATE_APPSTATE:
            return Object.assign({}, state, {
                formState: action.newState
            });
            break;
        default:
            return state;
    }
}

const rootReducer = combineReducers({
    showToast,
    appReducer,
    shifts,
    requestCount,
    scheduleDate,
    filteredShift,
    filteredRole,
    scheduleClear,
    scheduleConflicts,
    scheduleConflictsOnly,
    closeNav,
    closeChat,
    chatUserId,
    theme,
    filteredEmployee,
    refreshSchedule,
    profilePage,
    weather,
    clearingSchedule,
    fetching
})





export default rootReducer;